import CybsButton from '@cybs-ui/components/lib/button';
import React from 'react';
import PropTypes from 'prop-types';

import styles from '../styles/active.filter.styles';
import { kebabCase } from '../../../utils/StringUtils';

const noop = () => {};

const ActiveFilter = props => {
  const {
    cell,
    colIdx,
    dataTest,
    onClick,
    id,
    i18n: i18nProp,
    label,
    rowIdx,
    value,
    width
  } = props;

  const i18n = {
    ...ActiveFilter.defaultProps.i18n,
    ...i18nProp
  };

  const handleClick = () => {
    onClick(null, cell, rowIdx, colIdx);
  };
  const _getValue = () => {
    if (Array.isArray(value) && value.length > 0) {
      const { itemsSelectedLabel } = i18n;
      const output =
        value.length > 1
          ? `${cell.value.length} ${itemsSelectedLabel}`
          : cell.value[0].label;
      return output;
    }
    if (value && typeof value === 'string' && value.length) {
      return value;
    }

    return null;
  };

  const displayValue = _getValue();
  const ariaLabel = i18n.clearTooltip;

  const clearIcon = (
    <CybsButton
      dataTest={dataTest}
      id={id || kebabCase(label)}
      i18n={{
        ariaLabel
      }}
      iconClass="close"
      iconType="dark-tiny"
      onClick={handleClick}
      resolution="tiny"
      variant="icon"
    />
  );

  return (
    <div css={theme => styles(theme, width).container}>
      <span>{displayValue}</span>
      {clearIcon}
    </div>
  );
};

ActiveFilter.displayName = 'activeFilter';
ActiveFilter.propTypes = {
  // Would need to accomodate options for multiple table cells. Need a unified pattern for this
  // eslint-disable-next-line react/forbid-prop-types
  cell: PropTypes.object,
  colIdx: PropTypes.number.isRequired,
  dataTest: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  i18n: PropTypes.shape({
    clearTooltip: PropTypes.string,
    itemsSelectedLabel: PropTypes.string
  }),
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  rowIdx: PropTypes.number.isRequired,
  width: PropTypes.number,
  value: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ).isRequired
};

ActiveFilter.defaultProps = {
  cell: {},
  i18n: {
    clearTooltip: 'Clear filter',
    itemsSelectedLabel: 'items selected'
  },
  onClick: noop,
  width: 180
};

export default ActiveFilter;
